import React, { useState } from "react";
import H1 from "../Elements/H1";
import ScrollContent from "../ScrollContent";
import styled from "styled-components";
import { Learning, _Learnings } from "./Learning";
import LearningComponent from "./LearningComponent";
import Dialog, { HeightType } from "../DialogComponent";
import { Dialog2 } from "../Dialog2Component";
import { useLearningAuthentication } from "./useLearningAuthentication";
import '../App.css';

const Main = styled.main`
    padding: 0.5rem;
`;

export default function LearningsComponent() {
    const [learning, setLearning] = useState(null as null | Learning);
    const [password, setPassword] = useState('');
    const isOpen = learning !== null;

    const onOpen = (l: Learning) => {
        setLearning(l);
    }

    const auth = useLearningAuthentication();

    const onClose = () => setLearning(null);

    return <>
        <H1 className="z-index10000">講座</H1>
        {auth.isAuthend ? <ScrollContent>
            {_Learnings.map(learning => <LearningComponent learning={learning} onClick={onOpen} />)}
            <Dialog2 isOpen={isOpen} onClose={onClose} heightType={HeightType.Activity} zIndex={100}>
                {learning && <div className="youtube">
                    <iframe width="560" height="315" src={learning.youtubeUrl} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen/>
                </div>}
            </Dialog2>
        </ScrollContent> : <>
            <input type="number" value={password} className="input" placeholder="パスワードを入力してください" onChange={e => setPassword(e.target.value)} />
            <button className="button-primary" onClick={() => auth.onVerifyAuth(password)}>確認</button>
        </>}
    </>
};

